<template>
    <div class="alarm">
        <div class="title">
            <span class="text">告警流水</span>
            <el-button type="primary" size="small" text bg @click="toMorePage">
                更多
                <el-icon size="12">
                    <DArrowRight />
                </el-icon>
            </el-button>
        </div>
        <el-scrollbar>
            <div v-if="alarm_list?.length" class="alarm-record-container">
                <el-timeline>
                    <el-timeline-item
                        v-for="item in alarm_list"
                        :key="item.id"
                        :color="item.color"
                        :size="item.size"
                        :hollow="item.hollow"
                        :timestamp="item.happen_time"
                        center
                    >
                        <div class="alarm-item">
                            <div class="item-header">
                                <p class="device-name">{{ item.device_name || '未配置设备名称' }}</p>
                                <el-tag type="warning" size="small">
                                    <span v-if="item.alarm_type === 1">掉电故障</span>
                                    <span v-else-if="item.alarm_type === 2">位移故障</span>
                                    <span v-else-if="item.alarm_type === 3">离线故障</span>
                                    <div v-else-if="item.alarm_type === 4">市电掉电报警</div>
                                    <div v-else-if="item.alarm_type === 5">电池低电压报警</div>
                                    <div v-else-if="item.alarm_type === 6">防拆报警</div>
                                    <div v-else-if="item.alarm_type === 7">阀门堵转</div>
                                    <div v-else-if="item.alarm_type === 8">温度传感器报警</div>
                                </el-tag>
                            </div>
                            <p class="item-info">IMEI {{ item.device_imei }}</p>
                            <div class="item-info" :title="room_list[item.room]">
                                {{ room_list[item.room] ?? '未绑定位置' }}
                            </div>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div v-else class="noData">
                <div>暂无告警信息</div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue'
import { DArrowRight } from '@element-plus/icons'
import { useRouter } from 'vue-router'
import { getOptionTree } from '@/api/room.js'
import { getAlarmLogList } from '@/api/heating/monitoring.js'
// 判断路由
const router = useRouter()

const props = defineProps({
    morePagePath: {
        type: String,
        required: true
    },
    type: {
        type: Number,
        required: true
    }
})

// 更多
function toMorePage() {
    router.push({
        path: props.morePagePath,
        query: {
            type: props.type
        }
    })
}

// 安装位置
const room_list = ref({})
function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    getOptionTree().then((data) => {
        getRoom(data[0]?.children ?? [], '')
        room_list.value = room_locations
    })
}

// 告警流水
const alarm_list = ref([])
function getAlarmList() {
    getAlarmLogList({
        type: props.type
    }).then((res) => {
        alarm_list.value = res.lists
    })
}

onMounted(() => {
    getRoomTree()
    getAlarmList()
})
</script>

<style lang="scss" scoped>
.noData {
    width: 100%;
    height: calc(100% - 70px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.alarm {
    height: 100%;

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        span {
            font-size: 16px;
            font-weight: 700;
            color: #606266;
        }
    }
    .alarm-record-container {
        height: calc(100% - 70px);
        padding: 0 10px;

        :deep(.el-timeline-item__wrapper) {
            padding-left: 20px;
        }
        .alarm-item {
            padding-top: 5px;

            .item-header {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .device-name {
                    font-size: 14px;
                    font-weight: 700;
                    color: #606266;
                }
            }

            .item-info {
                width: 100%;
                font-size: 12px;
                color: #909399;
                line-height: 1.5;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 2px;
            }
        }
    }
}
</style>
